import { render, staticRenderFns } from "./ProductCard.vue?vue&type=template&id=412d1a43&"
import script from "./ProductCard.vue?vue&type=script&lang=js&"
export * from "./ProductCard.vue?vue&type=script&lang=js&"
import style0 from "./ProductCard.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BaseTag: require('/opt/build/repo/storefront/components/atoms/Tags/BaseTag.vue').default,DynamicImage: require('/opt/build/repo/storefront/components/atoms/Media/DynamicImage.vue').default,BaseLink: require('/opt/build/repo/storefront/components/atoms/Link/BaseLink.vue').default,RichText: require('/opt/build/repo/storefront/components/atoms/Text/RichText.vue').default,BaseHeading: require('/opt/build/repo/storefront/components/atoms/Text/BaseHeading.vue').default,BaseCopy: require('/opt/build/repo/storefront/components/atoms/Text/BaseCopy.vue').default,SwatchSelect: require('/opt/build/repo/storefront/components/molecules/Product/SwatchSelect.vue').default,BaseCard: require('/opt/build/repo/storefront/components/atoms/Card/BaseCard.vue').default})
